import DefaultConfig from './DefaultConfig';

export { DefaultConfig };
